/**
 * @Author: steve
 * @Date:   2017-Jun-10 12:35:38
 * @Last modified by:   steve
 * @Last modified time: 2017-Jun-10 12:38:48
 */

import Vue from 'vue'

export default new Vue()



// WEBPACK FOOTER //
// ./src/components/EventHub.js